
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Toast } from "vant";
import { StoreProductService } from "src/services";

@Component
export default class RightsPage extends Vue
{
    // 用于刷新子组件
    private keyNum: any = 0;

    // 样式
    private pageStyle: any = {};
    /**
     * 父组件传值
     * @private
     * @returns object
     */
    @Prop({type: Object, default: {}})
    private data: {};
    /**
    * 权益列表
    * @private
    * @returns boolean
    */
    private rightsList: any = [];

    /*
    * 获取权益列表
    * @private
    * @returns void
    */
    private async getRightsListByPost()
    {
        try {
            let ids = (this.data as any).properties.dataModel.map(item => item.id) || [];
            let { content: res } = await StoreProductService.instance.getRightsListByPost({ids});
            if(res.data)
            {
                this.rightsList = res.data
            }
        } catch (err) {
            Toast(err);
        }
    }

    /**
     * 跳转权益详情
     * @private
     * @returns void
     */
    private viewRightsDetail(id) {
        this.$router.push({name:"rights-shop-detail",query:{id}})
    }

    /**
     * 组件创建钩子
     */
    protected created() {
        this.getRightsListByPost();
    }

    /**
     * 值发生变化
     * @protected
     * @returns void
     */
     @Watch("data", {immediate: true, deep: true})
    private onDataChange(newValue: any): void
    {
        console.log();
        this.pageStyle = {'margin': newValue.properties.moduleSettings.upAndDown + 'px 0 0 0', 
        'background-color': newValue.properties.moduleSettings.bgColor,
        'border': newValue.properties.moduleSettings.contourLine && newValue.properties.moduleSettings.contourLine.show ? newValue.properties.moduleSettings.contourLine.width + 'px solid' + newValue.properties.moduleSettings.contourLine.color : '',
        'border-radius': newValue.properties.moduleSettings.contourLine && newValue.properties.moduleSettings.contourLine.show && !newValue.properties.moduleSettings.contourLine.corner ? '6px' : ''};
        this.keyNum++;
    }
}
